module.exports = __webpack_public_path__ + "static/media/gift-box-shadow-icon.be18f89c.svg";